import React, { useEffect, useState, useMemo } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'
import './AdmitPatientEvent.scss'
import moment from 'moment'
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import AdmitPatientEventEditConfirm from '../../ConfirmationModals/AdmitPatientEventEditConfirm'
import MobiScrollCalendar from '../../../../../../components/common/MobiScrollCalendar/MobiScrollCalendar'
import { getPatientEventHistory } from '../../../../../../helper/fusionHelper'
import {
  overwritePatientEvent,
  processPatientEventDate,
  visitFollowsDischarge,
} from './sharedPatientEventFunctions'
import { VISIT_STATUS } from '../../../../../../utils/statusConstants'

const today = format(new Date(), 'yyyy-MM-dd')

function getLaterDate(date) {
  return date > today ? date : today
}

// the special admit date that Medrina wants
export default function AdmitPatientEventModal({
  visit,
  onClose,
  onChange,
  date,
  isPatientEventCard = false,
}) {
  const [newDate, setNewDate] = useState(date)
  const [patientEventHistory, setPatientEventHistory] = useState([])

  const [warningDate, setWarningDate] = useState(null)
  const [isOverwrite, setIsOverwrite] = useState(null)

  // prevent spam clicks
  const [isClicked, setIsClicked] = useState(false)

  const admitPatientEventDate = visit?.admitPatientEvent?.date

  const processDateChange = (date) => {
    // if charge IDs are the same and dates are not the same
    if (
      visit.status !== VISIT_STATUS.last &&
      visit._id &&
      visit?.admitPatientEvent?.charge_id === visit._id &&
      moment.utc(admitPatientEventDate).toISOString() !== moment.utc(date).toISOString()
    ) {
      setWarningDate(date)
    } else {
      setNewDate(date)
    }
  }

  useEffect(() => {
    // get patientEvent history
    if (visit.patient_id) {
      getPatientEventHistory(visit.patient_id).then((patientEventHistory) => {
        setPatientEventHistory(patientEventHistory || [])
      })
    }
  }, [visit.patient_id])

  const service_date_from = visit?.service_date_from
  const showDischargeWarning = useMemo(() => {
    return visitFollowsDischarge(service_date_from, patientEventHistory)
  }, [service_date_from, patientEventHistory])

  return (
    <CModal
      className="confirm-modal"
      visible={true}
      onClose={onClose}
      fullscreen="lg"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">Edit Admission Date</CModalHeader>
      <CModalBody>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <div className="admit-date-selector">
            <div className="label">Admission Date</div>
            <div className="admit-date-input">
              <MobiScrollCalendar
                placeholder="MM / DD / YYYY"
                value={
                  showDischargeWarning
                    ? ''
                    : newDate || admitPatientEventDate
                      ? moment.utc(newDate || admitPatientEventDate).format('MM/DD/YYYY')
                      : ''
                }
                handleDateChange={processDateChange}
                disabled={Boolean(warningDate)}
                max={getLaterDate(visit?.service_date_from)}
              ></MobiScrollCalendar>
              {showDischargeWarning && !newDate && !isPatientEventCard && (
                <div id="warning-label">
                  *This encounter has no Admission Date following the most recent discharge. Please
                  update or leave blank.
                </div>
              )}
            </div>
          </div>
        </div>
        <AdmitPatientEventEditConfirm
          visible={Boolean(warningDate)}
          onClose={() => {
            setWarningDate(null)
          }}
          onConfirm={() => {
            setNewDate(warningDate)
            setWarningDate(null)
            setIsOverwrite(true)
          }}
        />
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cancel
        </CButton>
        <CButton
          color="primary"
          onClick={async () => {
            if (
              moment.utc(admitPatientEventDate).toISOString() === moment.utc(newDate).toISOString()
            ) {
              toast.error('Date is same as original encounter Admission Date')
              return
            }
            if (!isClicked) {
              setIsClicked(true)

              if (!isPatientEventCard) {
                let successful = isOverwrite
                  ? await overwritePatientEvent(newDate, visit?.admitPatientEvent)
                  : await processPatientEventDate(visit, newDate, 'ADMIT')
                if (!successful) {
                  setIsClicked(false)
                  return
                }
              }

              await onChange(newDate)
              setIsClicked(false)
            }
          }}
        >
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
